module.exports = __webpack_public_path__ + "static/img/img_background.cdead72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/bsop/img_background.jpg
// module id = NXNY
// module chunks = 0